import walletProviders, { WalletProvider } from './walletProviders';
import imgKStadiumMark from '../assets/img/kstadium-mark.png';

export type ChainSymbol = 'ETH' | 'KS_BESU';

export interface Chain {
  symbol: ChainSymbol;
  name: string;
  logoUrl: string;
  walletProviders: WalletProvider[];
  transferableChains: ChainSymbol[];
  disabledOnFrom?: boolean;
  explorerUrl: string;
  explorerTxPrefix: string;
  explorerAddressPrefix: string;
}

const ETH_EXPLORERS = {
  development: {
    explorerUrl: `https://sepolia.etherscan.io/`,
    explorerTxPrefix: `/tx/`,
    explorerAddressPrefix: `/address/`,
  },
  qa: {
    explorerUrl: `https://sepolia.etherscan.io/`,
    explorerTxPrefix: `/tx/`,
    explorerAddressPrefix: `/address/`,
  },
  stage: {
    explorerUrl: `https://sepolia.etherscan.io/`,
    explorerTxPrefix: `/tx/`,
    explorerAddressPrefix: `/address/`,
  },
  production: {
    explorerUrl: `https://etherscan.io`,
    explorerTxPrefix: `/tx/`,
    explorerAddressPrefix: `/address/`,
  },
};

const BESU_EXPLORERS = {
  development: {
    explorerUrl: `https://explorer.dev.kstadium.io`,
    explorerTxPrefix: `/tx/`,
    explorerAddressPrefix: `/account/`,
  },
  qa: {
    explorerUrl: `https://qa.testnet-explorer.mediumchain.io`,
    explorerTxPrefix: `/tx/`,
    explorerAddressPrefix: `/account/`,
  },
  stage: {
    explorerUrl: `https://explorer.stg.kstadium.io`,
    explorerTxPrefix: `/tx/`,
    explorerAddressPrefix: `/account/`,
  },
  production: {
    explorerUrl: `https://explorer.kstadium.io`,
    explorerTxPrefix: `/tx/`,
    explorerAddressPrefix: `/account/`,
  },
};

const chains: Chain[] = [
  {
    symbol: `ETH`,
    name: `Ethereum`,
    logoUrl: `/dummy/eth.webp`,
    walletProviders: walletProviders.filter(
      (provider) => provider.symbol === `METAMASK`,
    ),
    transferableChains: [`KS_BESU`],
    ...(ETH_EXPLORERS[process.env.REACT_APP_ENV] || ETH_EXPLORERS.development),
  },
  {
    symbol: `KS_BESU`,
    name: `K STADIUM GroundChain`,
    logoUrl: imgKStadiumMark,
    walletProviders: walletProviders.filter(
      (provider) => provider.symbol === `KSTADIUM`,
    ),
    transferableChains: [`ETH`],
    disabledOnFrom: true,
    ...(BESU_EXPLORERS[process.env.REACT_APP_ENV] || ETH_EXPLORERS.development),
  },
];

export const findChainBySymbol = (symbol: string): Chain | undefined =>
  chains.find((chain) => chain.symbol === symbol);

export default chains;
